import React from 'react';
import { Alert, AlertTitle, List, ListItem, ListItemText, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const ValidationAlert = ({ errors, onClose }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <Alert
      severity="error"
      action={
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      sx={{ mb: 2 }}
    >
      <AlertTitle>Validation Errors</AlertTitle>
      <List dense>
        {errors.map((error, index) => (
          <ListItem key={index}>
            <ListItemText primary={typeof error === 'string' ? error : JSON.stringify(error)} />
          </ListItem>
        ))}
      </List>
    </Alert>
  );
};

export default ValidationAlert;
